module.exports = __webpack_public_path__ + "root-c2082cbd/cd7bd7585eb6f0eda3a38fffb2113c59.woff";